/**
 * Who may see a SaleFish Legacy sync error: SaleFish Admins — the SUPER_ADMIN
 * role, labelled "SaleFish Admin" — and nobody else (Andrew, 2026-10-20: "DO
 * NOT SHOW ANY users SaleFish Legacy sync errors other than SaleFish Admins").
 *
 * A sync error is SaleFish's to fix, never the builder's: a vendor outage, a
 * credential, a list Legacy answered strangely. Shown to a sales rep or a
 * company admin it only alarms someone who can do nothing about it.
 *
 * "Error" covers everything that says the sync went wrong: the stale-data
 * banner, the last-sync error and sync history, a "Sync with Legacy" that
 * failed or finished with errors, a connection test, and a worksheet Legacy
 * would not take (its failed state, reason, retry, widget and notification).
 * Everyone else sees the data as it is and nothing about how it got there.
 *
 * Asked on both sides: the server strips the error from every response a
 * non-admin reads (server/lib/legacySyncErrors.ts), and every screen hides
 * the place it would have gone. Same rule as canAccessPlatformSettings.
 */
export function seesLegacySyncErrors(user: { role?: string | null } | null | undefined): boolean {
  return user?.role === "SUPER_ADMIN";
}
